import { Box, Button, Grid, Typography } from "@mui/material";

import styles from "./styles";

interface Props {
  snippet: string | JSX.Element;
  title: string | JSX.Element;
  description: string | JSX.Element;
  buttonText?: string;
  handleClick?: () => void;
}
const StyledBanner = ({
  snippet,
  title,
  description,
  buttonText,
  handleClick,
}: Props) => {
  return (
    <Grid container sx={styles.banner} gap={1}>
      <Grid item xs md>
        <Typography
          sx={{ textTransform: "uppercase", color: "black", fontWeight: 600 }}
          gutterBottom
        >
          <Box component="span" sx={{ color: "purple.dark" }}>
            {snippet}
          </Box>{" "}
          {title}
        </Typography>

        <Typography>{description}</Typography>
      </Grid>

      {buttonText && handleClick && (
        <Grid item xs={12} md="auto">
          <Button sx={styles.button} variant="outlined" onClick={handleClick}>
            {buttonText}
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default StyledBanner;
